import { DPS_API_BASE_URL } from "@gameApp/constants";
import WebApp from "@twa-dev/sdk";

export function whitelistStepsAuthTwitterUrlGet(): string {
  const path = "/social/linkX";
  const queryParams = `tgData=${encodeURIComponent(WebApp.initData)}`;
  const base = DPS_API_BASE_URL.replace(/\/+$/, "");

  return `${base}${path}?${queryParams}`;
}
